export const MOBILE_SCREEN_WIDTH = 767;
export const TABLET_SCREEN_WIDTH = 991;

export const mobile = `@media (max-width: ${MOBILE_SCREEN_WIDTH}px)`;
export const tablet = `@media (max-width: ${TABLET_SCREEN_WIDTH}px)`;
